import React from 'react'

import FormControl from './FormControl'

const withHookForm = Input => {
  return props => <FormControl customComponent={Input} {...props} />
}

export default withHookForm
